module.exports = __webpack_public_path__ + "img/ywjz4.a8c03026.png";